import { ProductSizeItem } from 'src/api/types';

export enum PublishType {
  PRODUCT = 'PRODUCT',
  PRICING = 'PRICING',
}

export interface IPublishFormValues {
  type: PublishType;
  venues: string[];
  priceSchemeId: string | null;
  instanceId: string | null;
  excludedItems?: ProductSizeItem[];
  publicationDate: Date | null;
  scheduleName?: string;
}

export enum Steps {
  type = 0,
  publishDetails = 1,
  instance = 2,
  venues = 3,
  excludeProducts = 4,
  summary = 5,
}
